var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeDate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7526 1H4.93308C2.76091 1 1 2.76088 1 4.93306V21.7526C1 23.9248 2.76091 25.6857 4.93308 25.6857H21.7526C23.9248 25.6857 25.6857 23.9248 25.6857 21.7526V4.93306C25.6857 2.76088 23.9248 1 21.7526 1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.83545H25.6857",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98302 13.3183H8.50289C8.65657 12.123 9.52752 11.3032 10.9791 11.3032C12.4648 11.3032 13.2504 12.1229 13.2504 13.3012C13.2504 14.7357 12.1403 15.3676 10.074 15.3847H9.66413V16.6825H10.0569C12.2769 16.6825 13.4894 17.3485 13.4894 19.0904C13.4894 20.3541 12.7039 21.3275 11.0474 21.3275C9.40796 21.3275 8.45166 20.32 8.29797 19.005H6.79517C6.983 21.3959 8.7249 22.6425 11.0645 22.6425C13.6431 22.6425 14.9752 21.1397 14.9752 19.2271C14.9752 17.451 14.0017 16.3922 12.5672 16.0507V15.9653C13.8651 15.6749 14.7531 14.565 14.7531 13.1476C14.7531 11.3715 13.4382 9.97119 11.0303 9.97119C8.74196 9.97119 7.13671 11.2008 6.98302 13.3183V13.3183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3196 22.5573H19.8907V10.2104H16.6802V11.6278H18.3196V22.5573Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6857,
    height: 26.6857,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeDate);
export default __webpack_public_path__ + "static/media/icon_type_date.7f1d1fa547627941acbe8331d5e3ef30.svg";
export { ForwardRef as ReactComponent };